import { request } from '@/common/appCtx';

const api = {
  getDeviceSettingsList(params: any) {
    return request.get('/api/wfm/admin/attendance_device_setting/setting_list', { params });
  },
  getAllDeviceList(params: any) {
    return request.post('/api/wfm/admin/attendance_device_setting/device_list', params);
  },
  getDeviceSettingsLogList(params: any) {
    return request.get('/api/wfm/admin/attendance_device_setting/setting_log_list', { params });
  },
  createDeviceSettings(params: any) {
    return request.post('/api/wfm/admin/attendance_device_setting/create', params);
  },
  updateDeviceSettings(params: any) {
    return request.post('/api/wfm/admin/attendance_device_setting/update', params);
  },
  deleteDeviceSettings(params: any) {
    return request.post(
      '/api/wfm/admin/attendance_device_setting/delete',
      params,
      {},
      { shouldNotNotifyError: true, shouldNotNotifyHttpError: true }
    );
  },
};

export default api;
